import { useState } from "react";
import Link from "next/link";
import { stepItems } from "./utils";
import routes from "@/constants/routes";
import RightArrow from "@/public/icons/hiw-right-arrow.svg";
import TimeClock from "@/public/icons/clock-orange-circle.svg";
import Step2Image from "@/public/icons/hiw-step2.svg";
import ExpandableBox from "@/components/landing-old/ExpandableBox";

const Step2 = (): JSX.Element => {
  const [activeIndex, setActiveIndex] = useState(-1);

  const clickHandler = (idx: number) => {
    setActiveIndex((current) => (current === idx ? -1 : idx));
  };

  return (
    <section className="relative bg-white w-full px-4 md:px-5 lg:px-20 lg:py-16">
      <div className="h-20 lg:h-0"></div>
      <h2 className="flex lg:hidden text-landing-orange font-bold text-2xl lg:text-3xl mb-3 lg:mb-5">
        Step 2
      </h2>
      <div className="flex flex-col lg:flex-row items-start">
        <div className="hidden lg:flex lg:justify-around lg:w-1/2 mr-5">
          <Step2Image width={"80%"} height={"100%"} />
        </div>
        <div className="flex flex-col lg:w-1/2 lg:mr-20">
          <h2 className="hidden lg:flex text-landing-orange font-bold text-2xl lg:text-3xl mb-3 lg:mb-5">
            Step 2
          </h2>
          <h3 className="text-4xl lg:text-5xl font-bold text-landing-blue mb-5 md:mb-3 lg:mb-5">
            Find your ideal home
          </h3>
          <div className="flex flex-col md:flex-row lg:flex-col items-center">
            <div className="w-full md:w-1/2 lg:w-full">
              <h4 className="font-serif text-xl lg:text-3xl text-landing-blue mb-5">
                The hunt is on! Have a look at our property listings and find something that suits
                you.
              </h4>
              <p className="font-base mb-5">
                If you find one you like that is within your budget, complete a short form to get
                started with Keyzy. If not, register your interest for homes in your area.
              </p>
              <p className="font-base mb-4 md:mb-12 lg:mb-9">
                If you qualify we can set up a viewing so you can decide if the home is right for
                you. You (and your fellow applicant) will then need to complete a full application.
              </p>
            </div>
            <div className="w-full md:w-1/2 lg:w-full hidden md:flex justify-around lg:hidden ">
              <Step2Image width={"90%"} height={"100%"} />
            </div>
          </div>
          <div className="flex flex-row justify-between mb-0 md:mb-6 lg:mb-9">
            <Link href={routes.searchHomes}>
              <a className="relative flex items-center" href={routes.searchHomes}>
                <span className={`relative text-base font-bold text-landing-orange`}>
                  Browse rent-to-own homes
                </span>
                <RightArrow className="md:ml-3 ml-1" />
              </a>
            </Link>
            <div className="flex flex-row justify-between items-center">
              <TimeClock className="mr-3" />
              <span className={`inline-block relative text-base text-landing-orange`}>1 week</span>
            </div>
          </div>
          <div className="md:hidden w-full my-5 flex justify-around">
            <Step2Image width={"80%"} height={"100%"} />
          </div>
          <div className="relative z-30 w-full">
            {stepItems.map((faq, idx) => (
              <div key={idx}>
                <ExpandableBox
                  question={faq.question}
                  answer={faq.answer}
                  active={activeIndex === idx}
                  clickHandler={() => clickHandler(idx)}
                  page={"hiw"}
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Step2;
